import API from 'services/api';

export const getProfileInfo = () => {
  return API.get('/api/profile');
};
